import { Link } from "react-router-dom";
import { Mail, Linkedin, Twitter } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-darkPaper border-t border-white/10 mt-32">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="font-heading font-bold text-2xl text-white" data-testid="footer-brand-name">
              Media Points Group
            </h3>
            <p className="text-gray-400 text-sm" data-testid="footer-tagline">
              Data Points. Touch Points. Turning Points.
            </p>
            <p className="text-gray-500 text-sm">
              AI-powered growth partner for ambitious brands.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" data-testid="footer-link-about" className="text-gray-400 hover:text-brandPrimary transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" data-testid="footer-link-services" className="text-gray-400 hover:text-brandPrimary transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/case-studies" data-testid="footer-link-case-studies" className="text-gray-400 hover:text-brandPrimary transition-colors text-sm">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/insights" data-testid="footer-link-insights" className="text-gray-400 hover:text-brandPrimary transition-colors text-sm">
                  Insights
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">AI-Driven Marketing Strategy</li>
              <li className="text-gray-400 text-sm">Brand Communication</li>
              <li className="text-gray-400 text-sm">Marketing Automation</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Get in Touch</h4>
            <Link
              to="/contact"
              data-testid="footer-cta-contact"
              className="inline-block bg-brandPrimary hover:bg-brandPrimary/90 text-white px-6 py-2.5 rounded-full text-sm font-medium transition-all mb-4"
            >
              Book a Strategy Call
            </Link>
            <div className="flex gap-4 mt-4">
              <a href="mailto:hello@mediapointsgroup.com" data-testid="footer-social-email" className="text-gray-400 hover:text-brandPrimary transition-colors" aria-label="Email">
                <Mail size={20} />
              </a>
              <a href="#" data-testid="footer-social-linkedin" className="text-gray-400 hover:text-brandPrimary transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="#" data-testid="footer-social-twitter" className="text-gray-400 hover:text-brandPrimary transition-colors" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Massive Tagline */}
        <div className="text-center mb-12 py-12">
          <h2 className="font-heading font-bold text-4xl md:text-6xl lg:text-7xl text-gradient" data-testid="footer-massive-tagline">
            Turning Points
          </h2>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm" data-testid="footer-copyright">
            © {new Date().getFullYear()} Media Points Group. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;